module.exports = __webpack_public_path__ + "img/ep1-17.f568d32f.png";